import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Activar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setData(data) {
        this.setState({
            valor: data.value
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.coeficientesue.activar}
                postUrl={api.proyectos.config.presupuesto.coeficientesue.activar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Coeficiente UE ha sido editado con éxito."}
                title={"Actualizar Coeficiente UE a Vigente"}
                buttonTitle={"Actualizar Coeficiente UE a Vigente"}
                buttonIcon={"fa fa-check fa-lg"}
                saveButtonLabel={"Activar"}
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-success btn-next"}
                onGotData={(data) => this.setData(data)}
            >
                <ParadigmaLabeledInput disabled fieldName="nombre" label="Nombre" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput disabled type={"number"} fieldName="valor" label="Valor" labelColumns={2} fieldColumns={10} />
                <ParadigmaLabeledInput disabled type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />

            </ParadigmaModal>
        );
    }
}

export default Activar;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesUE/Activar.js